import { useEffect, useRef, useState } from "react";
import { ReactComponent as CloseSvg } from "../../assets/icons/close.svg";
import {
  AdminActionButton,
  AdminActionsContainer,
  AngleDropdownChevron,
  AngleDropdownMenu,
  AngleDropdownOption,
  AngleDropdownTrigger,
  AngleDropdownWrapper,
  AngleDropdownsContainer,
  ModalContainer,
  ModalContent,
  ModalFooter,
  ModalTitle,
  ButtonGroup,
  Row,
  SmallRow,
  TitleContainer,
  Tags,
  Tag,
  FavoriteButton,
  NudifyContainer,
  Image,
  ImageContainer,
  NudifyText,
  FadeWrapper,
  SettingsContainer,
  LabelText,
  Column,
  Input,
  CheckboxContainer,
  Checkbox,
  CheckboxText,
  CheckboxContainerRow,
  ImageRelative,
  ArrowSvg,
  Textarea,
  DeleteButton,
  CropButton,
  UploadActions,
} from "./EditImageModal.styles";
import Modal from "../utils/Modal/Modal";
import { useLockBodyScroll } from "../../hooks/useLockBodyScroll";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";

import { ReactComponent as CreditIcon } from "../../assets/icons/credit.svg";
import { ReactComponent as CollectionDetailsIcon } from "../../assets/icons/collectionDetails.svg";
import { ReactComponent as CropIcon } from "../../assets/icons/crop.svg";

import { ReactComponent as PlaylistIcon } from "../../assets/icons/bookmark.svg";

import CustomizeEditImageModal from "../CustomizeEditImageModal/CustomizeEditImageModal";
import {
  selectGenerateImageCollectionPending,
  selectHideCollectionPending,
  selectHideCollectionVipPending,
  selectSelectedTrainModel,
  selectToggleToFavoriteLoading,
} from "../../store/slices/model/slice";
import {
  generateImageCollection,
  hideCollection,
  hideCollectionVip,
  toggleToFavorite,
} from "../../store/slices/model/asyncThunks";
import { selectUser } from "../../store/slices/user/slice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import {
  EDIT_IMAGE_MODEL_NAME,
  NUDIFY_MODEL_NAME,
  QWEN_Z_TWO_INPUT_IMAGES,
  TEXT_ON_BODY_MODEL_NAME,
  ALLOWED_HIDE_COLLECTION_USER_IDS,
  UPSCALE,
  CHANGE_ANGLE_MODEL_NAME,
  QWEN_Z_THREE_INPUT_IMAGES,
} from "../../utils/constants";
import AddToPlaylistModal from "../AddToPlaylistModal/AddToPlaylistModal";
import CreatePlaylistModal from "../CreatePlaylistModal/CreatePlaylistModal";
import LottieIcon from "../LottieIcon/LottieIcon";
import likeAnimation from "../../assets/animations/like.json";
import checkboxAnimation from "../../assets/animations/radioButton.json";
import radioButtonAnimation from "../../assets/animations/radioButton.json";
import settingsAnimation from "../../assets/animations/settings.json";
import deleteAnimation from "../../assets/animations/trash.json";
import FlyToCollection from "../FlyToCollection/FlyToCollection";
import { triggerCollectionTabAnimation } from "../../store/slices/common/slice";
import ExplosionButton from "../ExplosionButton/ExplosionButton";
import { useMediaQuery } from "react-responsive";
import CropModal from "../CropModal/CropModal";
import GenerationToast from "../utils/GenerationToast";
import { useScrollFade } from "../../hooks/useScrollFade";
import UserGalleryModal from "../UserGalleryModal/UserGalleryModal";
import CreateImageModal from "../CreateImageModal/CreateImageModal";
import SelectImageButton from "../SelectImageButton/SelectImageButton";
import UploadAdButton from "../PlayboxAdCard/UploadAdButton";

const WHERE_OPTIONS = [
  { id: "forehead", label: "Forehead" },
  { id: "face", label: "Face" },
  { id: "cheeks", label: "Cheeks" },
  { id: "neck", label: "Neck" },
  { id: "chest", label: "Chest" },
  { id: "tits", label: "Tits" },
  { id: "stomach", label: "Stomach" },
  { id: "pussy", label: "Pussy" },
  { id: "ass", label: "Ass" },
  { id: "dick", label: "Dick" },
  { id: "leg", label: "Leg" },
  { id: "arm", label: "Arm" },
];

const WRITING_STYLE_OPTIONS = [
  { id: "realistic", label: "Realistic" },
  { id: "stylish", label: "Stylish" },
  { id: "extreme", label: "Extreme" },
];

const GETTING_NAKED_OPTIONS = [
  { id: "natural", label: "Natural" },
  { id: "silicone", label: "Silicone" },
];

const HORIZONTAL_ROTATION_OPTIONS = [
  { id: "frontView", label: "Front View" },
  { id: "frontRightQuarterView", label: "Front-Right Quarter View" },
  { id: "rightSideView", label: "Right Side View" },
  { id: "backRightQuarterView", label: "Back-Right Quarter View" },
  { id: "backView", label: "Back View" },
  { id: "backLeftQuarterView", label: "Back-Left Quarter View" },
  { id: "leftSideView", label: "Left Side View" },
  { id: "frontLeftQuarterView", label: "Front-Left Quarter View" },
];

const VERTICAL_ANGLE_OPTIONS = [
  { id: "lowAngleShot", label: "Low-Angle Shot" },
  { id: "eyeLevelShot", label: "Eye-Level Shot" },
  { id: "elevatedShot", label: "Elevated Shot" },
  { id: "highAngleShot", label: "High-Angle Shot" },
];

const DISTANCE_OPTIONS = [
  { id: "closeUp", label: "Close-Up" },
  { id: "mediumShot", label: "Medium Shot" },
  { id: "wideShot", label: "Wide Shot" },
];

const DEFAULT_HORIZONTAL_ROTATION = "frontView";
const DEFAULT_VERTICAL_ANGLE = "lowAngleShot";
const DEFAULT_DISTANCE = "closeUp";

const AngleDropdown = ({ value, options, onChange, disabled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  const selectedOption = options.find((opt) => opt.id === value);

  return (
    <AngleDropdownWrapper ref={wrapperRef}>
      <AngleDropdownTrigger
        type="button"
        onClick={() => !disabled && setIsOpen((prev) => !prev)}
        disabled={disabled}
      >
        <span>{selectedOption?.label}</span>
        <AngleDropdownChevron $isOpen={isOpen} />
      </AngleDropdownTrigger>
      {isOpen && (
        <AngleDropdownMenu>
          {options.map((option) => (
            <AngleDropdownOption
              key={option.id}
              $selected={option.id === value}
              onClick={() => {
                onChange(option.id);
                setIsOpen(false);
              }}
            >
              {option.label}
            </AngleDropdownOption>
          ))}
        </AngleDropdownMenu>
      )}
    </AngleDropdownWrapper>
  );
};

const hasVipTag = (collection) =>
  Array.isArray(collection?.tags) &&
  collection.tags.some((tag) =>
    typeof tag === "string" ? tag === "VIP" : tag?.name === "VIP",
  );

const pause = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const EditImageModal = ({
  isOpen,
  onClose,
  collection,
  playlistId,
  fromTrainingSelectCoverPage,
  profilePage,
  profileUsername,
}) => {
  const dispatch = useDispatch();
  const selectedTrainModel = useSelector(selectSelectedTrainModel);
  const trainModelFromPage = fromTrainingSelectCoverPage
    ? selectedTrainModel?.data?.collections?.[0]?.trainModel
    : undefined;

  const [isOpenCustomizePromptModalOpen, setIsOpenCustomizePromptModalOpen] =
    useState(false);
  const navigate = useNavigate();

  const [isOpenCropModal, setIsOpenCropModal] = useState(false);
  const [cropTarget, setCropTarget] = useState(null); // null | 1 | 2
  const [isUserGalleryModalOpen, setIsUserGalleryModalOpen] = useState(false);
  const [isCreateImageFromGalleryOpen, setIsCreateImageFromGalleryOpen] =
    useState(false);
  const [galleryTarget, setGalleryTarget] = useState(null); // null = generate, 1 | 2 = fill slot

  const [bodyWritingText, setBodyWritingText] = useState("");

  const [nudifyEnabled, setNudifyEnabled] = useState(false);
  const [shouldEnhancePrompt, setShouldEnhancePrompt] = useState(false);
  const [upscaleEnabled, setUpscaleEnabled] = useState(false);

  const [customPrompt, setCustomPrompt] = useState("");

  const [seedNumber, setSeedNumber] = useState(
    Math.floor(Math.random() * 10000000) + 1,
  );

  const [where, setWhere] = useState("face");
  const [writingStyle, setWritingStyle] = useState("realistic");
  const [nakedStyle, setNakedStyle] = useState("natural");

  const [horizontalRotation, setHorizontalRotation] = useState(
    DEFAULT_HORIZONTAL_ROTATION,
  );
  const [verticalAngle, setVerticalAngle] = useState(DEFAULT_VERTICAL_ANGLE);
  const [distance, setDistance] = useState(DEFAULT_DISTANCE);

  const [uploadedImage, setUploadedImage] = useState(null);
  const [uploadedImage2, setUploadedImage2] = useState(null);
  const [uploadedImage3, setUploadedImage3] = useState(null);

  const user = useSelector(selectUser);

  const isOnCollectionUserProfile =
    profilePage &&
    !!collection?.username &&
    (profileUsername === collection.username ||
      user?.username === collection?.username);

  const loading = useSelector(selectToggleToFavoriteLoading);
  const generateLoading = useSelector(selectGenerateImageCollectionPending);
  const hideCollectionPending = useSelector(selectHideCollectionPending);
  const hideCollectionVipPending = useSelector(selectHideCollectionVipPending);

  const isLoading =
    loading ||
    generateLoading ||
    hideCollectionPending ||
    hideCollectionVipPending;
  const userId = user?._id || user?.id;
  const canManageCollectionVisibility =
    !!userId && ALLOWED_HIDE_COLLECTION_USER_IDS.includes(userId);

  const isEditImageModel = collection?.modelName === EDIT_IMAGE_MODEL_NAME;
  const isGettingNakedModel = collection?.modelName === NUDIFY_MODEL_NAME;
  const isBodywritingModel = collection?.modelName === TEXT_ON_BODY_MODEL_NAME;
  const isDoubleInputImageModel =
    collection?.modelType === QWEN_Z_TWO_INPUT_IMAGES;
  const isTripleInputImageModel =
    collection?.modelType === QWEN_Z_THREE_INPUT_IMAGES;

  const isChangeAngleModel = collection?.name === CHANGE_ANGLE_MODEL_NAME;

  const isUpscaleModel = collection?.modelType === UPSCALE;
  const hasPromptInput =
    (isEditImageModel && collection?.name === "Edit Image") ||
    isDoubleInputImageModel;

  const [isAddToPlaylistModalOpen, setIsAddToPlaylistModalOpen] =
    useState(false);
  const [isCreatingNew, setIsCreatingNew] = useState(false);
  const [isCreatePlaylistModalOpen, setIsCreatePlaylistModalOpen] =
    useState(false);
  const [playlistName, setPlaylistName] = useState("");

  const uploadedImageRef = useRef(null);
  const uploadedImage2Ref = useRef(null);
  const uploadedImage3Ref = useRef(null);
  const [isExploding, setIsExploding] = useState(false);
  const [isGeneratingFromGallery, setIsGeneratingFromGallery] = useState(false);

  // const [shouldShake, setShouldShake] = useState(false);
  // const [showOutline, setShowOutline] = useState(false);
  // const [agreeTos, setAgreeTos] = useState(false);

  const [flyAnimation, setFlyAnimation] = useState({
    isActive: false,
    imageUrl: null,
    startPosition: null,
    imageDimensions: null,
    onComplete: null,
  });

  const isMobile = useMediaQuery({ maxWidth: 768 });

  const [widthDifference, setWidthDifference] = useState(null);
  const [hideImageContainer, setHideImageContainer] = useState(null);
  const [isCollectionHiddenLocally, setIsCollectionHiddenLocally] =
    useState(false);
  const [isVipTagHiddenLocally, setIsVipTagHiddenLocally] = useState(false);
  const [confirmationAction, setConfirmationAction] = useState(null);

  const [whereBarRef, isWhereFaded] = useScrollFade("horizontal", [
    WHERE_OPTIONS,
    isOpen,
  ]);

  const checkWidthDifference = () => {
    setTimeout(() => {
      if (uploadedImageRef.current) {
        const imageWidth = uploadedImageRef.current.offsetWidth;
        const parentWidth = uploadedImageRef.current.parentElement.offsetWidth;
        const difference = parseInt((parentWidth - imageWidth) / 2);

        const maxDifference = isMobile ? 30 : 35;

        const hide = difference > 0 && difference < maxDifference;

        setWidthDifference(hide ? difference : 0);
        setHideImageContainer(hide);
      }
    }, 0);
  };

  useLockBodyScroll(isOpen || isOpenCustomizePromptModalOpen);

  useEffect(() => {
    setIsCollectionHiddenLocally(collection?.isPublic === false);
    setIsVipTagHiddenLocally(false);
  }, [collection?._id, collection?.isPublic]);

  // const handleCheckboxClick = () => {
  //   const newValue = !agreeTos;
  //   setAgreeTos(newValue);
  //   if (newValue) {
  //     setShowOutline(false);
  //   }
  // };

  const generateRandomSeed = () => {
    return Math.floor(Math.random() * 10000000) + 1;
  };

  const handleFavoriteToggle = () => {
    if (!loading && collection?._id) {
      dispatch(toggleToFavorite({ collectionId: collection?._id }));
    }
  };

  const handlePlaylistToggle = () => {
    if (!isLoading && collection._id) {
      setIsAddToPlaylistModalOpen(true);
    }
  };

  const hideCollectionAction = () => {
    if (!collection?._id || hideCollectionPending) {
      return;
    }

    const willShowCollection = isCollectionHidden;
    const hide = !willShowCollection;

    dispatch(hideCollection({ collectionId: collection._id, hide }))
      .unwrap()
      .then(() => {
        setIsCollectionHiddenLocally(!isCollectionHidden);
        setConfirmationAction(null);
        toast.success(
          willShowCollection
            ? "Collection shown successfully"
            : "Collection hidden successfully",
        );
      })
      .catch((err) => {
        toast.error(
          err ||
            (willShowCollection
              ? "Failed to show collection"
              : "Failed to hide collection"),
        );
      });
  };

  const hideCollectionVipAction = () => {
    if (!collection?._id || hideCollectionVipPending) {
      return;
    }

    const willShowVipTag = isVipTagHiddenLocally;
    const hide = !willShowVipTag;

    dispatch(hideCollectionVip({ collectionId: collection._id, hide }))
      .unwrap()
      .then(() => {
        setIsVipTagHiddenLocally(!isVipTagHiddenLocally);
        setConfirmationAction(null);
        toast.success(
          willShowVipTag
            ? "VIP tag shown successfully"
            : "Collection hidden from VIP category successfully",
        );
      })
      .catch((err) => {
        toast.error(
          err ||
            (willShowVipTag
              ? "Failed to show VIP tag"
              : "Failed to hide collection from VIP"),
        );
      });
  };

  const handleConfirmVisibilityAction = () => {
    if (confirmationAction === "hide") {
      hideCollectionAction();
      return;
    }

    if (confirmationAction === "hideVip") {
      hideCollectionVipAction();
    }
  };

  const selectWhere = (id) => {
    setWhere(id);
  };

  const selectWritingStyle = (id) => {
    setWritingStyle(id);
  };

  const validateForm = ({ hasGallerySelection = false } = {}) => {
    if (collection?.modelName === TEXT_ON_BODY_MODEL_NAME) {
      if (!bodyWritingText || !bodyWritingText.trim()) {
        toast.error("Body writing text is required");
        return false;
      }

      if (!where) {
        toast.error("Please select where to place the text");
        return false;
      }

      if (!writingStyle) {
        toast.error("Please select a writing style");
        return false;
      }
      if (!nakedStyle) {
        toast.error("Please select a style");
        return false;
      }
    } else if (isEditImageModel && collection?.name === "Edit Image") {
      if (!customPrompt || customPrompt.length === 0) {
        toast.error("Please add prompt");
        return false;
      }
    } else if (isDoubleInputImageModel) {
      if ((!hasGallerySelection && !uploadedImage) || !uploadedImage2) {
        toast.error("Please add input images", 400);
        return false;
      }
    } else if (isTripleInputImageModel) {
      if (
        (!hasGallerySelection && !uploadedImage) ||
        !uploadedImage2 ||
        !uploadedImage3
      ) {
        toast.error("Please add input images", 400);
        return false;
      }
    }

    return true;
  };

  const createGenerateImageCollectionFormData = ({
    image = uploadedImage,
    image2 = uploadedImage2,
    image3 = uploadedImage3,
    imageUrl = uploadedImage?.url,
    imageUrl2 = uploadedImage2?.url,
    imageUrl3 = uploadedImage3?.url,
  } = {}) => {
    const formData = new FormData();

    formData.append("collectionId", collection?._id);
    formData.append("nudify", nudifyEnabled);
    formData.append("upscale", upscaleEnabled);
    formData.append("shouldEnhancePrompt", shouldEnhancePrompt);

    if (bodyWritingText) {
      formData.append("text", bodyWritingText.trim());
    }
    if (where) {
      formData.append("placement", where);
    }

    if (writingStyle) {
      formData.append("writingStyle", writingStyle);
    }

    if (nakedStyle) {
      formData.append("style", nakedStyle);
    }

    formData.append("modelId", collection.model);

    if (customPrompt && customPrompt.trim()) {
      formData.append("customPrompt", customPrompt.trim());
    }

    if (seedNumber) {
      formData.append("seed", seedNumber);
    } else {
      formData.append("seed", generateRandomSeed());
    }

    if (image?.file) {
      formData.append("image", image.file, image.file.name);
    } else if (image?.sourceUrl || imageUrl) {
      formData.append("imageUrl", image?.sourceUrl || imageUrl);
    }

    if (image2?.file) {
      formData.append("image2", image2.file, image2.file.name);
    } else if (image2?.sourceUrl || imageUrl2) {
      formData.append("image2Url", image2?.sourceUrl || imageUrl2);
    }

    if (image3?.file) {
      formData.append("image3", image3.file, image3.file.name);
    } else if (image3?.sourceUrl || imageUrl3) {
      formData.append("image3Url", image3?.sourceUrl || imageUrl3);
    }

    if (playlistId) {
      formData.append("playlistId", playlistId);
    }

    if (trainModelFromPage) {
      formData.append("trainModel", trainModelFromPage);
    }

    if (isChangeAngleModel) {
      const horizontalLabel = HORIZONTAL_ROTATION_OPTIONS.find(
        (opt) => opt.id === horizontalRotation,
      )?.label;
      const verticalLabel = VERTICAL_ANGLE_OPTIONS.find(
        (opt) => opt.id === verticalAngle,
      )?.label;
      const distanceLabel = DISTANCE_OPTIONS.find(
        (opt) => opt.id === distance,
      )?.label;

      const composedPrompt =
        `${horizontalLabel} ${verticalLabel} ${distanceLabel}`.toLowerCase();
      formData.set("customPrompt", composedPrompt);
    }

    return formData;
  };

  const handleGenerationStarted = ({
    successMessage = "Generation started...",
  } = {}) => {
    toast.custom(() => (
      <GenerationToast
        successMessage={successMessage}
        label="View"
        onClick={() => {
          navigate("/collection");

          window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant",
          });
        }}
      />
    ));
  };

  const createGalleryImageSelection = (imageItem) => ({
    file: null,
    url: imageItem.url,
    sourceUrl: imageItem.url,
  });

  const prepareImageForCrop = async (image, target) => {
    if (image?.file || !image?.sourceUrl || image?.url?.startsWith("blob:")) {
      return image;
    }

    try {
      const response = await fetch(image.sourceUrl, { mode: "cors" });
      if (!response.ok) throw new Error("Failed to load gallery image");

      const blob = await response.blob();
      const preparedImage = {
        ...image,
        url: URL.createObjectURL(blob),
      };

      if (target === 3) {
        setUploadedImage3(preparedImage);
      } else if (target === 2) {
        setUploadedImage2(preparedImage);
      } else {
        setUploadedImage(preparedImage);
      }

      return preparedImage;
    } catch (error) {
      console.error("Failed to prepare gallery image for crop", error);
      return image;
    }
  };

  const openCropModalForTarget = async (target = null) => {
    const image =
      target === 3
        ? uploadedImage3
        : target === 2
          ? uploadedImage2
          : uploadedImage;
    if (!image) return;

    await prepareImageForCrop(image, target);
    setCropTarget(target);
    setIsOpenCropModal(true);
  };

  const handleConfirm = async () => {
    if (!validateForm()) {
      return;
    }

    // if (!agreeTos) {
    //   setShouldShake(true);
    //   setShowOutline(true);
    //   setTimeout(() => setShouldShake(false), 400);
    //   return;
    // }

    // localStorage.setItem("tosAccepted", "true");
    dispatch(generateImageCollection(createGenerateImageCollectionFormData()))
      .unwrap()
      .then(() => {
        handleGenerationStarted({
          successMessage: "Generation started...",
        });
        // Trigger explosion animation on button, then fly animation
        setIsExploding(true);

        // After explosion, start fly animation
        setTimeout(() => {
          setIsExploding(false);

          if (uploadedImage && uploadedImageRef.current) {
            setFlyAnimation({
              isActive: true,
              imageUrl: uploadedImage?.url,
              startPosition: uploadedImageRef.current.getBoundingClientRect(),
              imageDimensions: {
                width: uploadedImageRef.current.offsetWidth,
                height: uploadedImageRef.current.offsetHeight,
              },
              onComplete: () => {
                // Navigate to collection after animation
                const alreadyGeneratedVideo = localStorage.getItem(
                  "alreadyGeneratedVideo",
                );
                if (!alreadyGeneratedVideo) {
                  localStorage.setItem("alreadyGeneratedVideo", true);
                  navigate("/collection");

                  window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "instant",
                  });
                }

                // Reset animation
                setFlyAnimation({
                  isActive: false,
                  imageUrl: null,
                  startPosition: null,
                  imageDimensions: null,
                  onComplete: null,
                });
              },
            });

            // Close modal immediately when fly animation starts
            handleCancel();
          } else {
            // No image for animation, just close modal
            handleCancel();
          }
        }, 500); // Duration of explosion animation
      })
      .catch((err) => {
        toast.error(
          err ??
            "An error occurred while generating images. Please try again later.",
        );
      });
  };

  const resetStates = () => {
    setBodyWritingText("");
    setNudifyEnabled(false);
    setUpscaleEnabled(false);
    setWhere("face");
    setWritingStyle("realistic");
    setNakedStyle("natural");
    setCustomPrompt("");
    setUploadedImage(null);
    setUploadedImage2(null);
    setUploadedImage3(null);
    setHorizontalRotation(DEFAULT_HORIZONTAL_ROTATION);
    setVerticalAngle(DEFAULT_VERTICAL_ANGLE);
    setDistance(DEFAULT_DISTANCE);
    // setShouldShake(false);
    // setShowOutline(false);
    // setAgreeTos(false);
  };

  const handleCancel = () => {
    if (!isLoading) {
      resetStates();
      onClose();
    }
  };

  const displayImage =
    uploadedImage?.url ||
    collection?.input?.image?.resizedImage?.url ||
    collection?.input?.image?.url;

  const outputImage =
    collection?.output?.image?.url || collection?.input?.image?.url;
  const showHideVipTagButton =
    canManageCollectionVisibility &&
    (hasVipTag(collection) || isVipTagHiddenLocally);
  const isCollectionHidden =
    isCollectionHiddenLocally || collection?.isPublic === false;
  const confirmationTitle =
    confirmationAction === "hideVip"
      ? isVipTagHiddenLocally
        ? "Show VIP Tag"
        : "Hide VIP Tag"
      : isCollectionHidden
        ? "Show Collection"
        : "Hide Collection";
  const confirmationMessage =
    confirmationAction === "hideVip"
      ? isVipTagHiddenLocally
        ? "Are you sure you want to show this collection in the VIP category?"
        : "Are you sure you want to remove this collection from the VIP category?"
      : isCollectionHidden
        ? "Are you sure you want to show this collection?"
        : "Are you sure you want to hide this collection?";
  const confirmationLoading =
    confirmationAction === "hideVip"
      ? hideCollectionVipPending
      : hideCollectionPending;
  const enhancePromptExtra = hasPromptInput && shouldEnhancePrompt ? 5 : 0;
  const baseGeneratePrice = nudifyEnabled
    ? upscaleEnabled
      ? 45
      : 30
    : upscaleEnabled
      ? 30
      : 15;
  const galleryGeneratePrice = baseGeneratePrice + enhancePromptExtra;

  return (
    <>
      <CreateImageModal
        isOpen={isCreateImageFromGalleryOpen}
        onClose={() => setIsCreateImageFromGalleryOpen(false)}
        overlayZIndex={5000}
      />
      <UserGalleryModal
        isOpen={isUserGalleryModalOpen}
        onCreateImage={() => setIsCreateImageFromGalleryOpen(true)}
        onClose={() => {
          setIsUserGalleryModalOpen(false);
          setGalleryTarget(null);
        }}
        onConfirm={async (mediaItems) => {
          if (!mediaItems.length) {
            return;
          }

          if (mediaItems.some((mediaItem) => mediaItem.type === "video")) {
            toast.error("Please select an image");
            return false;
          }

          if (
            galleryTarget === 1 ||
            galleryTarget === 2 ||
            galleryTarget === 3
          ) {
            const selected = createGalleryImageSelection(mediaItems[0]);
            if (galleryTarget === 3) {
              setUploadedImage3(selected);
            } else if (galleryTarget === 2) {
              setUploadedImage2(selected);
            } else {
              setUploadedImage(selected);
            }
            setIsUserGalleryModalOpen(false);
            setGalleryTarget(null);
            return true;
          }

          if (!validateForm({ hasGallerySelection: true })) {
            return false;
          }

          try {
            setIsGeneratingFromGallery(true);
            let successfulGenerations = 0;

            for (const [index, mediaItem] of mediaItems.entries()) {
              try {
                await dispatch(
                  generateImageCollection(
                    createGenerateImageCollectionFormData({
                      image: null,
                      imageUrl: mediaItem.url,
                    }),
                  ),
                ).unwrap();

                successfulGenerations += 1;
              } catch (error) {
                console.error("Gallery generation failed", error);
              }

              if (index < mediaItems.length - 1) {
                await pause(300);
              }
            }

            if (!successfulGenerations) {
              throw new Error("Failed to start generation");
            }

            if (successfulGenerations !== mediaItems.length) {
              toast.error("Failed to start one or more generations");
            }

            handleGenerationStarted({
              successMessage:
                successfulGenerations === 1
                  ? "Generation started..."
                  : `${successfulGenerations} generations started...`,
            });
            handleCancel();

            return true;
          } catch (error) {
            toast.error(error.message || "Failed to start generation");
            return false;
          } finally {
            setIsGeneratingFromGallery(false);
          }
        }}
        selectedImages={[]}
        uploadedImagesCount={0}
        generatePrice={galleryGeneratePrice}
        maxSelectable={galleryTarget ? 1 : undefined}
        confirmLabel={galleryTarget ? "Select" : "Generate"}
        showPrice={!galleryTarget}
        overlayZIndex={3600}
        showUploadTile
        allowedMediaTypes={["image"]}
        isConfirmLoading={!galleryTarget && isGeneratingFromGallery}
        onOpenSettings={
          galleryTarget
            ? undefined
            : () => setIsOpenCustomizePromptModalOpen(true)
        }
      />
      <Modal
        isOpen={isOpen}
        onClose={() => {
          if (!isLoading) {
            onClose();
            resetStates();
          }
        }}
        customOverlayStyles={{ zIndex: 3100 }}
      >
        <ModalContainer $isBodywriting={isBodywritingModel}>
          <ModalContent>
            <TitleContainer>
              <Row>
                <ModalTitle>{collection?.name || "Model title"}</ModalTitle>
                <SmallRow>
                  <FavoriteButton
                    onClick={() => {
                      onClose();
                      navigate(`/template/${collection._id}`, {
                        state: { collection },
                      });

                      window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: "instant",
                      });
                    }}
                  >
                    <CollectionDetailsIcon />
                  </FavoriteButton>

                  <FavoriteButton onClick={handlePlaylistToggle}>
                    <PlaylistIcon />
                  </FavoriteButton>

                  <FavoriteButton style={{ zIndex: 1 }}>
                    <LottieIcon
                      animationData={likeAnimation}
                      trigger="toggle"
                      isToggled={user?.favoriteCollections?.includes(
                        collection?._id,
                      )}
                      onToggle={handleFavoriteToggle}
                      likeSegment={[1, 90]}
                      unlikeSegment={[90, 180]}
                      size={50}
                      absolute
                    />
                  </FavoriteButton>

                  <FavoriteButton
                    onClick={() => {
                      if (!isLoading) {
                        onClose();
                        resetStates();
                      }
                    }}
                  >
                    <CloseSvg />
                  </FavoriteButton>
                </SmallRow>
              </Row>
              <Tags>
                <Tag
                  $click
                  onClick={() => {
                    if (!isOnCollectionUserProfile) {
                      navigate(`/profile/${collection?.username}`);
                      window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: "instant",
                      });
                    }
                  }}
                >
                  @{collection?.username}
                </Tag>

                {!!collection?.keywords &&
                  collection?.keywords.length > 0 &&
                  collection?.keywords.map((keyword, i) => (
                    <Tag key={i}>{keyword}</Tag>
                  ))}
              </Tags>
              {canManageCollectionVisibility && (
                <AdminActionsContainer>
                  <AdminActionButton
                    onClick={() => setConfirmationAction("hide")}
                    disabled={hideCollectionPending}
                  >
                    {hideCollectionPending
                      ? "Saving..."
                      : isCollectionHidden
                        ? "Show"
                        : "Hide"}
                  </AdminActionButton>

                  {showHideVipTagButton && (
                    <AdminActionButton
                      onClick={() => setConfirmationAction("hideVip")}
                      disabled={hideCollectionVipPending}
                    >
                      {hideCollectionVipPending
                        ? "Saving..."
                        : isVipTagHiddenLocally
                          ? "Show VIP tag"
                          : "Hide VIP tag"}
                    </AdminActionButton>
                  )}
                </AdminActionsContainer>
              )}
            </TitleContainer>

            <ImageRelative style={{ width: "100%" }}>
              {isDoubleInputImageModel || isTripleInputImageModel ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  <ImageContainer
                    style={{
                      height: 116,
                      maxHeight: 116,
                    }}
                  >
                    {uploadedImage && (
                      <DeleteButton
                        $compact
                        onClick={() => {
                          setUploadedImage(null);
                        }}
                      >
                        <LottieIcon
                          animationData={deleteAnimation}
                          trigger="hover"
                          size={18}
                          strokeColor={"#fff"}
                        />
                      </DeleteButton>
                    )}
                    {uploadedImage && (
                      <CropButton
                        $compact
                        onClick={() => openCropModalForTarget(1)}
                      >
                        <CropIcon />
                      </CropButton>
                    )}
                    <Image
                      src={
                        uploadedImage?.url ||
                        collection?.input.image.resizedImage.url
                      }
                      alt="Model Before Image 1"
                      ref={uploadedImageRef}
                      $hideImageContainer={!uploadedImage?.url}
                    />
                    <UploadActions>
                      <SelectImageButton
                        onClick={() => {
                          if (isLoading) return;
                          setGalleryTarget(1);
                          setIsUserGalleryModalOpen(true);
                        }}
                        disabled={isLoading}
                        style={{ width: "100%" }}
                      />
                    </UploadActions>
                  </ImageContainer>
                  <ImageContainer
                    style={{
                      height: 116,
                      maxHeight: 116,
                    }}
                  >
                    {uploadedImage2 && (
                      <DeleteButton
                        $compact
                        onClick={() => {
                          setUploadedImage2(null);
                        }}
                      >
                        <LottieIcon
                          animationData={deleteAnimation}
                          trigger="hover"
                          size={18}
                          strokeColor={"#fff"}
                        />
                      </DeleteButton>
                    )}
                    {uploadedImage2 && (
                      <CropButton
                        $compact
                        onClick={() => openCropModalForTarget(2)}
                      >
                        <CropIcon />
                      </CropButton>
                    )}
                    <Image
                      src={uploadedImage2?.url || collection?.input.image.url}
                      alt="Model Before Image 2"
                      ref={uploadedImage2Ref}
                      $hideImageContainer={!uploadedImage2?.url}
                    />
                    <UploadActions>
                      <SelectImageButton
                        onClick={() => {
                          if (isLoading) return;
                          setGalleryTarget(2);
                          setIsUserGalleryModalOpen(true);
                        }}
                        disabled={isLoading}
                        style={{ width: "100%" }}
                      />
                    </UploadActions>
                  </ImageContainer>
                  {isTripleInputImageModel && (
                    <ImageContainer
                      style={{
                        height: 116,
                        maxHeight: 116,
                      }}
                    >
                      {uploadedImage3 && (
                        <DeleteButton
                          $compact
                          onClick={() => {
                            setUploadedImage3(null);
                          }}
                        >
                          <LottieIcon
                            animationData={deleteAnimation}
                            trigger="hover"
                            size={18}
                            strokeColor={"#fff"}
                          />
                        </DeleteButton>
                      )}
                      {uploadedImage3 && (
                        <CropButton
                          $compact
                          onClick={() => openCropModalForTarget(3)}
                        >
                          <CropIcon />
                        </CropButton>
                      )}
                      <Image
                        src={
                          uploadedImage3?.url ||
                          collection?.input.image.resizedImage?.url2 ||
                          collection?.input.image.url
                        }
                        alt="Model Before Image 3"
                        ref={uploadedImage3Ref}
                        $hideImageContainer={!uploadedImage3?.url}
                      />
                      <UploadActions>
                        <SelectImageButton
                          onClick={() => {
                            if (isLoading) return;
                            setGalleryTarget(3);
                            setIsUserGalleryModalOpen(true);
                          }}
                          disabled={isLoading}
                          style={{ width: "100%" }}
                        />
                      </UploadActions>
                    </ImageContainer>
                  )}
                </div>
              ) : (
                <ImageContainer>
                  {uploadedImage && (
                    <DeleteButton
                      onClick={() => {
                        setUploadedImage(null);
                      }}
                    >
                      <LottieIcon
                        animationData={deleteAnimation}
                        trigger="hover"
                        size={24}
                        strokeColor={"#fff"}
                      />
                    </DeleteButton>
                  )}
                  {uploadedImage && (
                    <CropButton
                      $shift={widthDifference}
                      onClick={() => openCropModalForTarget(null)}
                    >
                      <CropIcon />
                    </CropButton>
                  )}

                  <Image
                    src={displayImage}
                    alt="Model Before Image"
                    onLoad={checkWidthDifference}
                    ref={uploadedImageRef}
                    $hideImageContainer={
                      hideImageContainer || !uploadedImage?.url
                    }
                  />
                  {!isBodywritingModel && (
                    <UploadActions>
                      <UploadAdButton />
                      <SelectImageButton
                        onClick={() => {
                          setIsUserGalleryModalOpen(true);
                        }}
                        style={{ width: "100%" }}
                      />
                    </UploadActions>
                  )}
                </ImageContainer>
              )}
              {(isBodywritingModel ||
                isDoubleInputImageModel ||
                isTripleInputImageModel) && <ArrowSvg />}

              <ImageContainer>
                <Image
                  src={outputImage}
                  alt="Model After Image"
                  $hideImageContainer
                />
              </ImageContainer>
            </ImageRelative>

            {!isBodywritingModel &&
              !isUpscaleModel &&
              !isDoubleInputImageModel &&
              !isTripleInputImageModel &&
              !isChangeAngleModel && (
                <SettingsContainer>
                  <NudifyContainer
                    onClick={() => {
                      if (!isLoading) {
                        setUpscaleEnabled(!upscaleEnabled);
                      }
                    }}
                  >
                    <LottieIcon
                      animationData={checkboxAnimation}
                      speed={2}
                      trigger="toggle-reverse"
                      isActive={upscaleEnabled}
                      onActiveChange={() => {
                        if (!isLoading) {
                          setUpscaleEnabled(!upscaleEnabled);
                        }
                      }}
                      onClick={() => {
                        if (!isLoading) {
                          setUpscaleEnabled(!upscaleEnabled);
                        }
                      }}
                      size={24}
                      strokeColor={!upscaleEnabled ? "#2877d9" : "#ffffff"}
                    />
                    <NudifyText>Enhance photo before edit</NudifyText>
                  </NudifyContainer>
                </SettingsContainer>
              )}

            {hasPromptInput && (
              <NudifyContainer
                style={{ marginTop: isDoubleInputImageModel ? 0 : -5 }}
                onClick={() => {
                  setShouldEnhancePrompt(!shouldEnhancePrompt);
                }}
              >
                <LottieIcon
                  animationData={checkboxAnimation}
                  trigger="toggle-reverse"
                  isActive={shouldEnhancePrompt}
                  speed={2}
                  onActiveChange={() => {
                    setShouldEnhancePrompt(!shouldEnhancePrompt);
                  }}
                  onClick={() => {
                    setShouldEnhancePrompt(!shouldEnhancePrompt);
                  }}
                  size={24}
                  strokeColor={"#2877d9"}
                />
                <CheckboxText>Enhance prompt before generation</CheckboxText>
              </NudifyContainer>
            )}

            {isGettingNakedModel ? (
              <SettingsContainer>
                <Column>
                  <LabelText>Style</LabelText>

                  <CheckboxContainerRow>
                    {GETTING_NAKED_OPTIONS.map((option) => {
                      const isChecked = nakedStyle === option.id;

                      return (
                        <Checkbox
                          $checked={isChecked}
                          key={option.id}
                          onClick={() => !isLoading && setNakedStyle(option.id)}
                        >
                          <LottieIcon
                            animationData={radioButtonAnimation}
                            speed={2}
                            trigger="toggle-reverse"
                            isActive={isChecked}
                            size={22}
                            strokeColor={!isChecked ? "#2877d9" : "#ffffff"}
                          />

                          <CheckboxText>{option.label}</CheckboxText>
                        </Checkbox>
                      );
                    })}
                  </CheckboxContainerRow>
                </Column>
              </SettingsContainer>
            ) : isBodywritingModel ? (
              <SettingsContainer>
                <NudifyContainer
                  onClick={() => {
                    if (!isLoading) {
                      setUpscaleEnabled(!upscaleEnabled);
                    }
                  }}
                >
                  <LottieIcon
                    animationData={checkboxAnimation}
                    speed={2}
                    trigger="toggle-reverse"
                    isActive={upscaleEnabled}
                    onActiveChange={() => {
                      if (!isLoading) {
                        setUpscaleEnabled(!upscaleEnabled);
                      }
                    }}
                    onClick={() => {
                      if (!isLoading) {
                        setUpscaleEnabled(!upscaleEnabled);
                      }
                    }}
                    size={24}
                    strokeColor={!upscaleEnabled ? "#2877d9" : "#ffffff"}
                  />
                  <NudifyText>Enhance photo before applying text</NudifyText>
                </NudifyContainer>
                <NudifyContainer
                  onClick={() => {
                    if (!isLoading) {
                      setNudifyEnabled(!nudifyEnabled);
                    }
                  }}
                >
                  <LottieIcon
                    animationData={checkboxAnimation}
                    speed={2}
                    trigger="toggle-reverse"
                    isActive={nudifyEnabled}
                    onActiveChange={() => {
                      if (!isLoading) {
                        setNudifyEnabled(!nudifyEnabled);
                      }
                    }}
                    onClick={() => {
                      if (!isLoading) {
                        setNudifyEnabled(!nudifyEnabled);
                      }
                    }}
                    size={24}
                    strokeColor={!nudifyEnabled ? "#2877d9" : "#ffffff"}
                  />
                  <NudifyText>Nudify before applying text</NudifyText>
                </NudifyContainer>

                <Column>
                  <SmallRow>
                    <LabelText>Text</LabelText>
                    {/* <InfoIcon width={18} height={18} /> */}
                  </SmallRow>
                  <Input
                    type="text"
                    placeholder="Enter the bodywriting text…"
                    value={bodyWritingText}
                    onChange={(e) => setBodyWritingText(e.target.value)}
                    disabled={isLoading}
                  />
                </Column>

                <Column>
                  <LabelText>Where?</LabelText>

                  <FadeWrapper $faded={isWhereFaded}>
                    <CheckboxContainer ref={whereBarRef}>
                      {WHERE_OPTIONS.map((option) => {
                        const isChecked = where === option.id;

                        return (
                          <Checkbox
                            key={option.id}
                            $checked={isChecked}
                            onClick={() => !isLoading && selectWhere(option.id)}
                          >
                            <LottieIcon
                              animationData={radioButtonAnimation}
                              trigger="toggle-reverse"
                              speed={2}
                              isActive={isChecked}
                              size={22}
                              strokeColor={!isChecked ? "#2877d9" : "#ffffff"}
                            />
                            <CheckboxText>{option.label}</CheckboxText>
                          </Checkbox>
                        );
                      })}
                    </CheckboxContainer>
                  </FadeWrapper>
                </Column>

                <Column>
                  <LabelText>Writing Style</LabelText>

                  <CheckboxContainerRow>
                    {WRITING_STYLE_OPTIONS.map((option) => {
                      const isChecked = writingStyle === option.id;

                      return (
                        <Checkbox
                          $checked={isChecked}
                          key={option.id}
                          onClick={() =>
                            !isLoading && selectWritingStyle(option.id)
                          }
                        >
                          <LottieIcon
                            animationData={radioButtonAnimation}
                            speed={2}
                            trigger="toggle-reverse"
                            isActive={isChecked}
                            strokeColor={!isChecked ? "#2877d9" : "#ffffff"}
                            size={22}
                          />
                          <CheckboxText>{option.label}</CheckboxText>
                        </Checkbox>
                      );
                    })}
                  </CheckboxContainerRow>
                </Column>
              </SettingsContainer>
            ) : isChangeAngleModel ? (
              <AngleDropdownsContainer>
                <AngleDropdown
                  value={horizontalRotation}
                  options={HORIZONTAL_ROTATION_OPTIONS}
                  onChange={setHorizontalRotation}
                  disabled={isLoading}
                />
                <AngleDropdown
                  value={verticalAngle}
                  options={VERTICAL_ANGLE_OPTIONS}
                  onChange={setVerticalAngle}
                  disabled={isLoading}
                />
                <AngleDropdown
                  value={distance}
                  options={DISTANCE_OPTIONS}
                  onChange={setDistance}
                  disabled={isLoading}
                />
              </AngleDropdownsContainer>
            ) : hasPromptInput ? (
              <SettingsContainer>
                <Column>
                  <SmallRow>
                    <LabelText>Prompt</LabelText>
                  </SmallRow>
                  <Textarea
                    style={{
                      minHeight: isDoubleInputImageModel ? 88 : 126,
                    }}
                    type="text"
                    placeholder={
                      isDoubleInputImageModel
                        ? "Woman hugs man"
                        : (collection?.customPrompt ??
                          "Enter the custom prompt here")
                    }
                    value={customPrompt}
                    onChange={(e) => setCustomPrompt(e.target.value)}
                    disabled={isLoading}
                  />
                </Column>
              </SettingsContainer>
            ) : (
              <></>
            )}
          </ModalContent>

          <ModalFooter>
            <ButtonGroup>
              {!isChangeAngleModel && (
                <LottieIcon
                  animationData={settingsAnimation}
                  trigger="hover"
                  strokeColor={"#fff"}
                  size={28}
                  onClick={() =>
                    !isLoading && setIsOpenCustomizePromptModalOpen(true)
                  }
                />
              )}
              <ExplosionButton
                style={{ margin: "0px 6px", flex: 1 }}
                disabled={generateLoading}
                onClick={handleConfirm}
                isLoading={generateLoading}
                isExploding={isExploding}
                small
              >
                {generateLoading ? (
                  <l-line-spinner
                    size="16"
                    stroke="1.25"
                    speed="1.5"
                    color="black"
                  />
                ) : (
                  // <l-pulsar
                  //   size="24"
                  //   stroke="2"
                  //   speed="2.2"
                  //   color="rgba(63, 136, 247, 1)"
                  // />
                  <>
                    Generate
                    <CreditIcon />
                    {galleryGeneratePrice}
                  </>
                )}
              </ExplosionButton>
            </ButtonGroup>
            {/* <TermsCheckboxComponent
              handleCheckboxClick={handleCheckboxClick}
              agreeTos={agreeTos}
              shouldShake={shouldShake}
              showOutline={showOutline}
              offMarginTop
              offHorizontalMargin
              showAlways
            /> */}
          </ModalFooter>
        </ModalContainer>
      </Modal>

      <AddToPlaylistModal
        isOpen={isAddToPlaylistModalOpen}
        isCreatingNew={isCreatingNew}
        setIsCreatingNew={setIsCreatingNew}
        openCreatePlaylistModal={() => {
          setIsCreatePlaylistModalOpen(true);
        }}
        onClose={() => setIsAddToPlaylistModalOpen(false)}
        collectionId={collection?._id}
      />
      <CreatePlaylistModal
        playlistName={playlistName}
        setPlaylistName={setPlaylistName}
        isOpen={isCreatePlaylistModalOpen}
        onClose={() => setIsCreatePlaylistModalOpen(false)}
      />

      <CropModal
        selectedImage={
          cropTarget === 3
            ? uploadedImage3
            : cropTarget === 2
              ? uploadedImage2
              : uploadedImage
        }
        onClose={() => {
          setIsOpenCropModal(false);
          setCropTarget(null);
        }}
        onConfirm={(croppedImageData) => {
          const cropped = {
            file: new File(
              [croppedImageData.blob],
              `cropped-${Date.now()}.jpg`,
              { type: "image/jpeg" },
            ),
            url: croppedImageData.url,
            blob: croppedImageData.blob,
          };
          if (cropTarget === 3) {
            setUploadedImage3(cropped);
          } else if (cropTarget === 2) {
            setUploadedImage2(cropped);
          } else {
            setUploadedImage(cropped);
          }
          setCropTarget(null);
        }}
        isOpen={isOpenCropModal}
      />

      <ConfirmationModal
        isOpen={!!confirmationAction}
        onClose={() => setConfirmationAction(null)}
        onConfirm={handleConfirmVisibilityAction}
        title={confirmationTitle}
        message={confirmationMessage}
        confirmText="Confirm"
        cancelText="Cancel"
        confirmButtonType="danger"
        isLoading={confirmationLoading}
      />

      <CustomizeEditImageModal
        isOpen={isOpenCustomizePromptModalOpen}
        onClose={() => setIsOpenCustomizePromptModalOpen(false)}
        customPrompt={customPrompt}
        setCustomPrompt={setCustomPrompt}
        seedNumber={seedNumber}
        setSeedNumber={setSeedNumber}
        generateRandomSeed={generateRandomSeed}
        collectionSeed={collection?.seed}
        isEditImageModel={
          (isEditImageModel && collection?.name === "Edit Image") ||
          isDoubleInputImageModel
        }
        overlayZIndex={3700}
        resetSeed={isOpen}
      />

      {flyAnimation.isActive && (
        <FlyToCollection
          isActive={flyAnimation.isActive}
          imageUrl={flyAnimation.imageUrl}
          startPosition={flyAnimation.startPosition}
          imageDimensions={flyAnimation.imageDimensions}
          onComplete={() => {
            dispatch(triggerCollectionTabAnimation());

            // Call callback from handleConfirm if provided
            if (flyAnimation.onComplete) {
              flyAnimation.onComplete();
            }

            setFlyAnimation({
              isActive: false,
              imageUrl: null,
              startPosition: null,
              imageDimensions: null,
              onComplete: null,
            });
          }}
        />
      )}
    </>
  );
};

export default EditImageModal;
